/**
 * @type {LineStyle}
 */
// @ts-ignore
export const NONE = 'NONE'
/**
 * @type {LineStyle}
 */
// @ts-ignore
export const DASHED = 'DASHED'
/**
 * @type {LineStyle}
 */
// @ts-ignore
export const SOLID = 'SOLID'
/**
 * @type {LineStyle}
 */
// @ts-ignore
export const DOTTED = 'DOTTED'

/**
 * @typedef {import('../index').LineStyle} LineStyle
 */

/**
 * @type {Array<LineStyle>}
 */
export const ALL_STYLES = [NONE, DASHED, SOLID, DOTTED]

/**
 * @param {number} length
 * @return {LineStyle}
 */
export function nextBorderStyle(length) {
  return ALL_STYLES[length % ALL_STYLES.length]
}
